import { graphql } from "@/graphql/codegen"

graphql(`
  mutation RemovePayFileApproval($input: PayFileRemoveApprovalInput!) {
    payFile {
      removeApproval(input: $input) {
        __typename
        ... on PayFileRemoveApprovalSuccess {
          payFile {
            payFileId
          }
        }
        ... on PayFileRemoveApprovalFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
